<template>
    <b-navbar toggleable="md"  :sticky="true" class="top-bar">
      <b-navbar-brand :to="{ name: ContractorRouteNames.dashboard }" >
          <img :src="$root.serverBasePath + '/strata.png'" alt="Strata Connex" height="40px"/>
        </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto center-bar">
          <b-nav-item :to="{ name: ContractorRouteNames.dashboard }" :active="isActive(ContractorRouteNames.dashboard)">Dashboard</b-nav-item>
          <b-nav-item :to="{ name: ContractorRouteNames.compliance}" :active="isActive(ContractorRouteNames.compliance)">Compliance</b-nav-item>
          <b-nav-item :to="{ name: ContractorRouteNames.quote }" :active="isActive(ContractorRouteNames.quote)">Quotes</b-nav-item>
          <b-nav-item :to="{ name: ContractorRouteNames.workOrder }" :active="isActive(ContractorRouteNames.workOrder)">Work Orders</b-nav-item>
<!--          <b-nav-item>Contacts</b-nav-item>-->
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto bar-right">
<!--			<b-nav-item href="#"><i class="fas fa-question-circle fa-lg"></i></b-nav-item>-->

			<b-nav-item-dropdown right class="sub-nav">
				<template #button-content>
					<img :src="$root.serverBasePath + '/images/profile-placeholder.png'" alt="user image" class="nav-img">
					<span class="nav-img-color"></span>
				</template>

				<div class="user-info py-3">
					<b-dropdown-item>{{ $store.state.authenticatedUserData.user.full_name
					}}</b-dropdown-item>
					<b-dropdown-item>{{ $store.state.authenticatedUserData.business? $store.state.authenticatedUserData.business.company_name : ''
					}}</b-dropdown-item>
				</div>

				<hr>

                <div class="user-nav">
				    <b-dropdown-item :to="{ name: 'edit-contractor-profile' }"><i class="fa fa-user fa-lg mr-3" aria-hidden="true"></i>Profile</b-dropdown-item>
				    <b-dropdown-item :to="{ name: 'contractor-add-members' }"><i class="fa fa-building fa-lg mr-3" aria-hidden="true"></i>Manage Org</b-dropdown-item>
				    <b-dropdown-item @click="logout"><i class="fas fa-sign-out-alt fa-lg mr-3"></i>Logout</b-dropdown-item>
                </div>
			</b-nav-item-dropdown>
		</b-navbar-nav>
      </b-collapse>
    </b-navbar>
</template>

<script>
import {ContractorRouteNames, ContractorMainRoutes} from "../../../routeNames";

export default {
    computed: {
        ContractorRouteNames() {
            return ContractorRouteNames
        },
        currentRoute() {
            return this.$route.name;
        }
    },
  mounted(){
    //navbar script
    // let menu = document.querySelector('.bd-nav')
    // let firstChild = menu.firstElementChild
    // let x = firstChild

    // firstChild.classList.add('tab-dot-active')
  },
  methods: {
    logout() {
      var fcn_token = localStorage.getItem('fcm_token_uuid');

      axios.post("logout",{fcn_token}).then(() => {
            // location.reload();
        this.$store.commit("setUserLoggedOut");
        this.$router.push({ name: "login" });
      });
    },
    isActive(routeName) {
        return ContractorMainRoutes[routeName].includes(this.currentRoute);
    }
  },

};



</script>

